import get from 'lodash/get';
import {
  getDocumentFields,
  getFileUrl,
  getOptimizedContentfulImage,
} from 'utils/helper';

export const useKeyFeatures = ({ features, type }) => {
  const containerBackgroundImage = getOptimizedContentfulImage(
    getFileUrl(get(features, 'images[0]', {})),
    { fm: 'png' },
  );
  const containerStyle = containerBackgroundImage ? { backgroundImage: `url(${containerBackgroundImage})` } : {};
  const isEmptyContentModules = !get(features, 'contentModules');

  const content = features.contentModules?.map((data) => {
    const { title, text, contentList } = getDocumentFields(data);

    const icon = contentList?.[0];

    return { title, text, icon };
  });

  return {
    type,
    content,
    containerStyle,
    isEmptyContentModules,
    icon: containerBackgroundImage,
  };
};
